(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["findly-choose-glow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('findly-choose-glow')) {
    customElements.define('findly-choose-glow', class extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this._i = 0;
        this.addEventListener('click', (e) => {
          const pill = e.target.closest('.fcg__pill');
          if (pill) { this._show(+pill.dataset.i); return; }
          if (e.target.closest('.fcg__cta')) this._choose();
        });
      }
      _show(i) {
        this._i = i;
        this.querySelectorAll('[data-i]').forEach((el) => el.classList.toggle('is-active', +el.dataset.i === i));
      }
      _choose() {
        const pill = this.querySelector('.fcg__pill[data-i="' + this._i + '"]');
        const colour = pill ? pill.dataset.colour : null;
        if (colour) {
          const tile = document.querySelector('.findly-colors__tile[data-value="' + CSS.escape(colour) + '"]');
          if (tile) tile.click();
          else {
            const input = [...document.querySelectorAll('variant-picker input[type="radio"]')].find((r) => r.value === colour);
            if (input && !input.checked) input.click();
          }
        }
        const target = document.querySelector('.findly-colors') || document.querySelector('variant-picker') || document.querySelector('main');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
